(function () {
  function initPhb(section) {
    var hotspots = section.querySelectorAll('.phb-hotspot');
    var cards = section.querySelectorAll('.phb-card');

    function clear() {
      cards.forEach(function (c) {
        c.classList.remove('is-dimmed');
        c.classList.remove('is-active');
      });
    }

    hotspots.forEach(function (hotspot) {
      var handle = hotspot.getAttribute('data-phb-handle');
      var match = section.querySelector('.phb-card[data-phb-handle="' + handle + '"]');
      var on = function () {
        if (!match) return;
        cards.forEach(function (c) { if (c !== match) c.classList.add('is-dimmed'); });
        match.classList.add('is-active');
      };
      hotspot.addEventListener('mouseenter', on);
      hotspot.addEventListener('focus', on);
      hotspot.addEventListener('mouseleave', clear);
      hotspot.addEventListener('blur', clear);
    });

    var btn = section.querySelector('.phb-add-all');
    if (!btn) return;
    var msg = section.querySelector('.phb-message');
    var label = btn.textContent;
    var items = [];
    try { items = JSON.parse(btn.getAttribute('data-items') || '[]'); } catch (e) { items = []; }

    btn.addEventListener('click', function () {
      if (!items.length) return;
      btn.disabled = true;
      btn.textContent = 'Se adaugă…';
      if (msg) msg.textContent = '';

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (e) { throw e; });
          return res.json();
        })
        .then(function () {
          window.location.href = window.Shopify.routes.root + 'cart';
        })
        .catch(function (err) {
          btn.disabled = false;
          btn.textContent = label;
          if (msg) msg.textContent = (err && err.description) || 'Nu am putut adăuga produsele în coș. Încearcă din nou.';
        });
    });
  }

  document.querySelectorAll('.phb-section').forEach(initPhb);
})();